import {
  type CSSProperties,
  type KeyboardEvent,
  type MouseEvent,
  useEffect,
  useState,
} from "react";
import styled from "styled-components";
import { Form, ListGroup } from "react-bootstrap";

import { NameID } from "common/types/NameID";
import { MapPoint } from "common/types/MapArea";
import { useAreas } from "common/hooks/useAreas";

type Props = {
  areas: NameID[];
  point?: MapPoint;
  readonly?: boolean;
  maxHeight?: string;
  style?: CSSProperties;
  borderAlways?: boolean;
  onClick: () => void;
};

//=====================================
// NameIDのリストを表示する
//=====================================
export const MapAreaList = (props: Props) => {
  const {
    areas,
    point,
    readonly = false,
    borderAlways = false,
    maxHeight = "200px",
    style,
    onClick,
  } = props;
  const [vals, setVals] = useState<NameID[]>([]);
  const { toPointString } = useAreas();

  const processKeyEvent = (e: KeyboardEvent<HTMLElement>) => {
    if (readonly) return;
    switch (e.key) {
      case "Enter":
      case " ":
        onClick();
        break;
    }
  };

  useEffect(() => {
    setVals(areas);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areas]);

  return (
    <ListGroup
      as="ul"
      style={{ maxHeight: maxHeight, overflow: "auto", ...style }}
      tabIndex={0}
      onKeyUp={processKeyEvent}
    >
      {point && (
        <SListItem
          $readOnly={readonly}
          $borderAlways={borderAlways}
          onClick={(e: MouseEvent<HTMLElement>) => {
            if (readonly) return;
            onClick();
          }}
        >
          <Form.Label>{toPointString(point)}</Form.Label>
        </SListItem>
      )}
      {!point && vals.length === 0 && (
        <SListItem
          $readOnly={readonly}
          $borderAlways={borderAlways}
          onClick={() => {
            if (readonly) return;
            onClick();
          }}
        >
          <Form.Label>選択なし</Form.Label>
        </SListItem>
      )}

      {vals.map((val) => (
        <SListItem
          key={`val_${val.id}`}
          $readOnly={readonly}
          $borderAlways={borderAlways}
          onClick={() => {
            if (readonly) return;
            onClick();
          }}
        >
          <Form.Label>{val.name}</Form.Label>
        </SListItem>
      ))}
    </ListGroup>
  );
};

const SListItem = styled(ListGroup.Item)<{ $readOnly: boolean; $borderAlways: boolean }>`
  cursor: ${(props) => (props.$readOnly ? "default" : "pointer")};
  border-style: ${(props) => (!props.$readOnly || props.$borderAlways ? "solid" : "none")};
  margin: 0;
  vertical-align: baseline;
  padding: 0.375rem 0.75rem;
  color: #777;
  label {
    cursor: ${(props) => (props.$readOnly ? "default" : "pointer")};
    padding: 0 0;
    margin: 0;
  }
`;
